import React from 'react';
import { Dialog, DialogProps } from '@mui/material';
import { BORDER_COLORS } from '../../utils/colors';
import { DIALOG } from '../../utils/responsive';

interface GlassDialogProps extends DialogProps {
  children: React.ReactNode;
}

/**
 * Glass morphism styled Dialog component
 * Consistent dark theme without blue tints
 */
const GlassDialog: React.FC<GlassDialogProps> = ({ children, ...props }) => {
  return (
    <Dialog
      {...props}
      PaperProps={{
        ...props.PaperProps,
        sx: {
          borderRadius: 3,
          background: '#141414',
          border: `1px solid ${BORDER_COLORS.DEFAULT}`,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.5)',
          // Плотность полей на телефоне — как в диалогах кабинета (там эти же значения
          // проставлены по месту). Без этого длинные русские подписи вроде
          // «Название группы (необязательно)» не влезают в вырез рамки и обрезаются:
          // на 320px ширина диалога всего 256px.
          '@media (max-width: 599.95px)': {
            '& .MuiInputLabel-root': { fontSize: DIALOG.contentFontSize.xs },
            '& .MuiInputBase-input': { fontSize: DIALOG.contentFontSize.xs },
            '& .MuiFormHelperText-root': { fontSize: DIALOG.helperTextFontSize.xs },
            '& .MuiMenuItem-root': { fontSize: DIALOG.contentFontSize.xs },
          },
          ...props.PaperProps?.sx,
        },
      }}
    >
      {children}
    </Dialog>
  );
};

export default GlassDialog;
